import React from "react";
import { Box } from "@mui/material";
import FieldLabel from "./FieldLabel";

export default function ControlField({ icon, label, children }) {
  return (
    <Box>
      <FieldLabel icon={icon}>{label}</FieldLabel>
      {children}
    </Box>
  );
}